// // import React from 'react';
// // import { Button } from './ui/button';
// // import { finalCta } from '../mockData';

// // const FinalCta = () => {
// //   return (
// //     <section className="py-20 px-6 bg-gradient-blue-strong bg-tech-dots">
// //       <div className="max-w-7xl mx-auto">
// //         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
// //           <div>
// //             <h2 className="text-4xl md:text-5xl font-bold mb-6">{finalCta.title}</h2>
// //             <p className="text-lg text-gray-600 mb-8">{finalCta.subtitle}</p>
// //             <Button className="bg-black text-white hover:bg-gray-800 rounded-lg px-8 py-4 mb-12">
// //               {finalCta.cta}
// //             </Button>

// //             <div className="space-y-6">
// //               {finalCta.features.map((feature, index) => (
// //                 <div key={index}>
// //                   <h3 className="font-bold text-xl mb-2">{feature.title}</h3>
// //                   <p className="text-gray-600">{feature.description}</p>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>

// //           <div className="rounded-3xl overflow-hidden shadow-2xl">
// //             <img src={finalCta.image} alt="Dashboard" className="w-full h-auto" />
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default FinalCta;

// import React from 'react';
// import { Button } from '@/components/ui/button';
// import { finalCta } from '@/mockData';

// const FinalCta = () => {
//   return (
//     // DIUBAH: Dihapus 'bg-gradient-blue-strong bg-tech-dots'
//     <section className="py-20 px-6">
//       <div className="max-w-7xl mx-auto">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
//             <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">{finalCta.title}</h2>
//             {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
//             <p className="text-lg text-gray-300 mb-8">{finalCta.subtitle}</p>
//             {/* Tombol ini (hitam) sudah kontras dengan background gelap, jadi tidak diubah */}
//             <Button className="bg-white text-black hover:bg-gray-200 rounded-lg px-8 py-4 mb-12">
//               {finalCta.cta}
//             </Button>

//             <div className="space-y-6">
//               {finalCta.features.map((feature, index) => (
//                 <div key={index}>
//                   {/* DIUBAH: Teks judul fitur diubah menjadi 'text-white' */}
//                   <h3 className="font-bold text-xl mb-2 text-white">{feature.title}</h3>
//                   {/* DIUBAH: Teks deskripsi fitur diubah menjadi 'text-gray-300' */}
//                   <p className="text-gray-300">{feature.description}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="rounded-3xl overflow-hidden shadow-2xl">
//             <img src={finalCta.image} alt="Dashboard" className="w-full h-auto" />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FinalCta;

import React from 'react';
import { Button } from '@/components/ui/button';
import { finalCta } from '@/mockData';
import FlowingMenu from './FlowingMenu'; // <-- DIIMPOR
import './FlowingMenu.css'; // <-- DIIMPOR

const FinalCta = () => {
  // Data demo untuk FlowingMenu
  const demoItems = [
    { link: '#', text: 'Shipping', image: 'https://kontentutorialmpstore-cdn.maduraprime.com/be439ce5-03b2-47b8-b279-b26e490a1cf6.png' },
    { link: '#', text: 'QRIS', image: 'https://kontentutorialmpstore-cdn.maduraprime.com/a8e6a3de-3132-48f9-b578-adaa536830ee.svg' },
    { link: '#', text: 'VA BANK', image: 'https://kontentutorialmpstore-cdn.maduraprime.com/a78770b2-3f6f-4d5e-aa70-9364d6467143.png' },
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* DIUBAH: Tata letak diubah menjadi flex column dan tengahkan */}
        <div className="flex flex-col items-center text-center">
          {/* Wrapper untuk teks, dibatasi lebarnya */}
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">{finalCta.title}</h2>
            <p className="text-lg text-gray-300 mb-8">{finalCta.subtitle}</p>
            <Button className="bg-white text-black hover:bg-gray-200 rounded-lg px-8 py-4 mb-12">
              {finalCta.cta}
            </Button>

            {/* Fitur-fitur DIHAPUS
            <div className="space-y-6">
              {finalCta.features.map((feature, index) => (
                <div key={index}>
                  <h3 className="font-bold text-xl mb-2 text-white">{feature.title}</h3>
                  <p className="text-gray-300">{feature.description}</p>
                </div>
              ))}
            </div>
            */}
          </div>

          {/* GAMBAR DIHAPUS
          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img src={finalCta.image} alt="Dashboard" className="w-full h-auto" />
          </div>
          */}

          {/* FlowingMenu DITAMBAHKAN DI SINI */}
          {/* DIUBAH: mt-20 (margin-top) dihapus agar menu nempel di bawah tombol */}
          <div className="w-full" style={{ height: '600px', position: 'relative' }}>
            <FlowingMenu items={demoItems} />
          </div>

        </div>
      </div>
    </section>
  );
};

export default FinalCta;